export default __webpack_public_path__ + "3cae9feef310771aa0943a07b2fb66a7.png";